/*
 * A helper function that is passed a string like 'white' and returns a tailwind background color.
 */

import { keyframes } from '@emotion/react';

import tailwindColors from '../../tailwind-colors';

const movingGradient = keyframes`
  from {background-position: 0;}
  to {background-position: 100%;}
`;

const animatedCyanBlueGradient = `
  background-image: linear-gradient(
    -45deg,
    ${tailwindColors.blue[800]},
    ${tailwindColors.blue[700]},
    ${tailwindColors.blue[600]},
    ${tailwindColors.cyan[600]}
  );
  background-size: 400%;
  animation: ${movingGradient} 15s ease infinite alternate;
`;

const backgroundColorMap = {
  white: `bg-white`,
  black: `bg-black`,
  gray25: `bg-gray-25`,
  gray50: `bg-gray-50`,
  gray500: `bg-neutral`,
  blue500: `bg-primary`,
  blue600: `bg-primary-dark`,
  blue700: `bg-primary-darker`,
  cyan400: `bg-cyan-400`,
  cyan600: `bg-cyan-600`,
  purple500: `bg-violet-500`,
  lightCyanGradient: `bg-gradient-to-br from-cyan-600 to-cyan-500`,
  cyanBlueGradient: `bg-gradient-to-br from-cyan-600 via-primary to-primary-dark`,
  blueDarkBlueGradient: `bg-gradient-to-br from-primary to-primary-darker`,
  animatedCyanBlueGradient,
};

const getBackgroundColor = color => backgroundColorMap[color];

export default getBackgroundColor;
